import React, { Component } from "react"

/* Constants */
import { utils, env } from "../constants"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* Moment Settings */
moment.locale("ru")


/* Component Video */
class Video extends Component {

    constructor() {
        super()

        this.state = {
            thumbnail: null
        }
    }

    componentDidMount = () => {
        this.generateThumbnail()
    }

    /* Generate Thumbnail */
    generateThumbnail = () => {

        /* Fields */
        const { data } = this.props

        /* Check Video */
        if (!data.link) {
            return
        }

        /* Create Video */
        const video = document.createElement("video")
        video.src = `${env.point}${data.link}`
        video.crossOrigin = "anonymous"
        video.muted = true
        video.preload = "auto"

        /* On Load */
        video.addEventListener("loadeddata", () => {
            video.currentTime = 1
        })

        /* On Ready */
        video.addEventListener("seeked", () => {
            const canvas = document.createElement("canvas")
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight

            const ctx = canvas.getContext("2d")
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

            const imageURL = canvas.toDataURL("image/jpeg")
            this.setState({ thumbnail: imageURL })
        })
    }

    render = () => {

        /* Fields */
        const { thumbnail } = this.state
        const { data, open } = this.props

        return (
            <div onClick={() => open()} className="stream-video">

                {/* Thumbnail */}
                {thumbnail && <img src={thumbnail} alt="Thumbnail" className="thumbnail" />}

                {/* Play Image */}
                <img src="/images/play-button.png" alt="Play" className="play" />

                <div className="stream-video-duration">{utils.formatTime(data.duration)}</div>
                <div className="stream-video-time">{moment(data.createdAt).format("HH:mm")}</div>
                {data.mark === 1 && <div className="stream-video-mark" />}
                {data.recording === 0 && <div className="stream-video-recording">Запись ...</div>}

            </div>
        )
    }
}

export default Video